import { render, staticRenderFns } from "./ReceiptAttachmentsModal.vue?vue&type=template&id=6260551d"
import script from "./ReceiptAttachmentsModal.vue?vue&type=script&lang=js"
export * from "./ReceiptAttachmentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports